import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { ResultadoAnaliseRow } from 'src/modules/motor-credito/bordero/bordero.types'
import { Observable, observe, Scope } from 'wdc-cube'

@Observable
export class ResultadoAnaliseVisaoCedenteScope extends Scope {
    @observe() waiting?: WaitingScope
    @observe() resultados = {} as Record<string, ResultadoAnaliseRow[]>

    onClose = Scope.ASYNC_ACTION
}

export default ResultadoAnaliseVisaoCedenteScope
